const reducerName = '@cityoo-backoffice/territories/parishes';

export const RESET = `${reducerName}/RESET`;

export const GET_PARISHES_START = `${reducerName}/GET_PARISHES_START`;
export const GET_PARISHES_SUCCESS = `${reducerName}/GET_PARISHES_SUCCESS`;
export const GET_PARISHES_FAIL = `${reducerName}/GET_PARISHES_FAIL`;
